import { xml2ast } from '@utils/ast';
import { createCacheWrapper } from '@utils/cache';
import { DAYS_TO_MS } from '@utils/constants';
import { linkNodeParsers } from './common.links.js';
import { accordionComponentParsers } from './component.accordion.js';
export { makeAccordionComponentParsers } from './component.accordion.js';
import { cardsComponentParsers } from './component.cards.js';
export { cardsComponentInTeacherSectionParsers } from './component.cards.js';
import { ctaComponentParsers } from './component.cta.js';
import { gridComponentParsers } from './component.grid.js';
import { iframeComponentParsers } from './component.iframe.js';
import { imageComponentParsers } from './component.image.js';
export { parseImageComponent } from './component.image.js';
import { mediaComponentParsers } from './component.media.js';
import { sliderComponentParsers } from './component.slider.js';
import { splitComponentParsers } from './component.split.js';
import { textComponentParsers } from './component.text.js';
export { parseTextComponent } from './component.text.js';
import { resolveComponentFrameworkNodes } from './util.resolve-component-framework-nodes.js';
export { parseTextComponentHtmlNode, textComponentHtmlParsers } from './component.text.html.js';

const pageParsers = {
  ...accordionComponentParsers,
  ...cardsComponentParsers,
  ...ctaComponentParsers,
  ...gridComponentParsers,
  ...iframeComponentParsers,
  ...imageComponentParsers,
  ...mediaComponentParsers,
  ...sliderComponentParsers,
  ...splitComponentParsers,
  ...textComponentParsers,
  ...linkNodeParsers
};
const cache = createCacheWrapper({
  capacity: 100,
  timeToLiveMs: 1 * DAYS_TO_MS
});
async function parsePageXML(queryClient, xml, user, parsers = pageParsers) {
  return cache(
    `${xml}-${user == null ? void 0 : user.id}`,
    () => resolveComponentFrameworkNodes(
      queryClient,
      xml2ast(xml, parsers).filter((it) => it.nodeType !== "text"),
      user
    )
  ).getStaleWhileRevalidate();
}
const elementParsers = {
  ...iframeComponentParsers,
  ...imageComponentParsers,
  ...mediaComponentParsers,
  ...sliderComponentParsers,
  ...splitComponentParsers,
  ...textComponentParsers,
  ...linkNodeParsers
};
async function parseElementXML(queryClient, xml, user, parsers = elementParsers) {
  return resolveComponentFrameworkNodes(
    queryClient,
    xml2ast(xml, parsers).filter((it) => it.nodeType !== "text"),
    user
  );
}

export { accordionComponentParsers, cardsComponentParsers, ctaComponentParsers, gridComponentParsers, iframeComponentParsers, imageComponentParsers, linkNodeParsers, mediaComponentParsers, pageParsers, parseElementXML, parsePageXML, sliderComponentParsers, splitComponentParsers, textComponentParsers };
//# sourceMappingURL=index.js.map
